import { forOwn, isEmpty, forEach, camelCase, replace, map, isArray } from 'lodash';
import React, { Component } from 'react';
import { boDauTiengViet } from 'src/util/Common';

// Những vai trò chưa được xác định và quyền admin dùng đường dẫn mặc định
// /he-thong/quyen
const redirectByVaiTroValue = {
  heThong: '/he-thong/quyen',
  admin: '/he-thong/quyen',
  bcAttp: '/bao-cao/ve-sinh-attp/bao-cao-ve-sinh-attp',
  bcBaoCaoDuAnThdt: '/bao-cao/bao-cao-tinh-hinh-dau-tu/bao-cao-du-an',
  bcCho: '/bao-cao/cho/quan-ly-cho',
  bcCoSoHaTangThdt: '/danh-muc/danh-muc-cum-cong-nghiep/co-so-ha-tang',
  bcBanBuonThuocLa: '/bao-cao/thuoc-la/bao-cao-thuoc-la',
  bcCumCongNghiep: '/bao-cao/bao-cao-cum-cn/bao-cao-ccn',
  bcRuou: '/bao-cao/ruou/bao-cao-ruou',
  bcVln: '/danh-muc/vat-lieu-no-cong-nghiep/cap-phep-vat-lieu-no-cong-nghiep',
  bcXd: '/danh-muc/xang-dau/cua-hang-xang-dau',
  bcpktatmtAll: '/danh-muc/vat-lieu-no-cong-nghiep/cap-phep-vat-lieu-no-cong-nghiep',
  bcpqlcnAll: '/bao-cao/bao-cao-cum-cn/bao-cao-ccn',
  bcqltmAll: '/danh-muc/xang-dau/cua-hang-xang-dau',
  bcRuouCongNghiep: '/bao-cao/ruou/ruou-cong-nghiep',
  bcGas: '/bao-cao/gas/bao-cao-gas',
  bcSxKdRuou: '/bao-cao/ruou/bao-cao-sx-kd-ruou',
  dmBaoCaoCumCcn: '/bao-cao/bao-cao-cum-cn/bao-cao-ccn',
  dmCumCongNghiep: '/danh-muc/danh-muc-cum-cong-nghiep/cum-cong-nghiep',
  dmQuanLyCho: '/danh-muc/cho/loai-cho',
  dmRuou: '/danh-muc/ruou/loai-ruou',
  dmThuocLa: '/danh-muc/thuoc-la/co-so-ban-le-thuoc-la',
  dmVatLieuNo: '/danh-muc/vat-lieu-no-cong-nghiep/doanh-nghiep',
  dmVeSinhAttp: '/danh-muc/ve-sinh-attp/nganh-nghe-kinh-doanh',
  dmXangDau: '/danh-muc/xang-dau/co-quan-chu-quan',
  dmall: '/danh-muc/ve-sinh-attp/nganh-nghe-kinh-doanh',
  qtht: '/he-thong/quyen',
  dmqlbbtl: '/danh-muc/quan-ly-nha-ban-buon-thuoc-la/nha-ban-buon',
  tkAll: '/thong-ke/cua-hang-gas',
  tkThdthatang: '/thong-ke/tong-hop-dau-tu-ha-tang',
  tkCuaHangGas: '/thong-ke/cua-hang-gas',
  tkCsvsattp: '/thong-ke/ve-sinh-attp',
  tkPhatTrienCho: '/thong-ke/phat-trien-cho',
  tkGiayPhepVlncn: '/thong-ke/cap-giay-phep-vlncn',
  tkTongHopCsvsAttp: '/thong-ke/tong-hop-cssxkd',
  tkTongHopThdtxdKetCauHaTang: '/thong-ke/tong-hop-dau-tu-ha-tang',
  thuongNhan: '/bao-cao/ruou/ruou-cong-nghiep',
}

/**
 * Tạo danh sách vai trò theo key
 * @param {*} vaiTroAll
 */
export const genListVaiTro = async (vaiTroAll, status = false) => {
  let data = [];
  if (!isEmpty(vaiTroAll)) {
    data = vaiTroAll;
  }
  let valueData = {};
  if (!isEmpty(data)) {
    await forEach(data, item => {
      let maVaiTro = replace(item.maVaiTro, /^\d*_?/g, '');
      maVaiTro = camelCase(maVaiTro);
      valueData[maVaiTro] = {
        actived: status,
        quyens: {}
      };
      valueData[maVaiTro].quyens = item.quyens;
    });
  }
  return valueData;
}

/**
 * Chuyển đổi mảng array vai trò của người dùng thành một mảng dạng camel
 * Thành phần này dùng để đối chiếu và xuất ra link redirect tương ứng với vai trò
 * người dùng có
 *
 * @param {*} vaiTroUser
 * @returns Ví dụ: ['bcqltmAll', 'bcpqlcnAll']
 */
export const convertVaiTroUserToListAsCamel = (vaiTroUser) => {
  if (isArray(vaiTroUser) && !isEmpty(vaiTroUser)) {
    return map(vaiTroUser, vaiTro => camelCase(replace(vaiTro.maVaiTro, /^\d*_?/g, '')));
  } else {
    return [];
  }
}

/**
 * Xử lý dữ liệu vai trò, quyền của người dùng
 * Tiến hành kích hoạt những vai trò người dùng có
 * @param {*} vaiTroAll Tất cả vao trò
 * @param {*} vaiTros Vai trò của người dùng
 * @returns
 */
export const vaiTros = async (vaiTroAll, vaiTros) => {
  let vaiTroRefillData = [];
  await vaiTroAll.forEach(vaiTroMain => {
    vaiTros.forEach(vaiTro => {
      if(vaiTroMain.maVaiTro === vaiTro.maVaiTro) {
        vaiTroRefillData = [...vaiTroRefillData, { ...vaiTroMain }];
      }
    })
  });
  let listVaiTroAll = await genListVaiTro(vaiTroAll);
  let listVaiTro = {};
  if (!isEmpty(vaiTroRefillData)) {
    listVaiTro = await genListVaiTro(vaiTroRefillData, true);
  }
  return { ...listVaiTroAll, ...listVaiTro };
}

/**
 * Lấy danh sách vai trò từ user
 *
 * @param {*} userInfo
 * @returns
 */
export const listVaiTro = (userInfo) => {
  let vaiTros = [];
  if (userInfo && userInfo.user) {
    vaiTros = userInfo.user.vaiTros;
  }
  return vaiTros;
}

/**
 * Chuyển trang dựa theo vai trò trả về
 *
 * @param {array} vaiTroKey
 * @returns
 */
export const extractToRedirect = (vaiTroKey) => {
  let foundUrl = false;
  if(isArray(vaiTroKey) && !isEmpty(vaiTroKey) && !foundUrl) {
    foundUrl = true;
    return redirectByVaiTroValue[vaiTroKey[0]];
  }
  return '/he-thong/quyen';
}

/**
 * Xử lý vai trò có thể vào Component hay không
 *
 * @param {*} WrappedComponent - Component đầu vào
 * @param {*} selectData - Vai trò
 * @param {*} vaiTroKeyword - Vai trò từ component
 * @param {*} isRoot - Nếu là root sẽ tiến hành truyền danh sách vai trò sang component con
 * @returns Component có quyền vào hay không ?
 */
export const Authentication = (WrappedComponent, selectData, vaiTroKeyword, isRoot = false) => {
  // Xử lý dữ liệu
  let actived = false;
  let quyens = [];
  let isAdmin = false;
  let isXem = false;
  if(isEmpty(selectData)) {
    actived = true;
    quyens = [
      { id: 1, tenQuyen: "Sửa" },
      { id: 2, tenQuyen: "Thêm" },
      { id: 3, tenQuyen: "Xoá" },
      { id: 4, tenQuyen: "Xem" }
    ]
  } else {
    map(vaiTroKeyword, item => {
      // Trường hợp còn lại
      forOwn(selectData, (value, key) => {
        if (key === item && value.actived === true) {
          actived = true;
          quyens = value.quyens;
          if (key === 'admin') {
            isAdmin = true;
          }
          if(key === 'xem'){
            isXem = true;
          }
        }
      });
    });
  }

  // Xử lý trên Component
  return class extends Component {
    render() {
      const vaiTroStatus = { actived, quyens, isAdmin, vaiTroKeyword, isXem };
      return <WrappedComponent status={vaiTroStatus} selectData={isRoot ? selectData : []} {...this.props} />
    }
  }
}
/**
 * Kiểm tra vai trò với menu
 *
 * @param {*} selectData
 * @param {array} vaiTroKeyword
 * @returns Nếu có vai trò thì trả về true và ngược lại là false
 */
export const AuthenticationMenu = (selectData, vaiTroKeyword) => {
  // Xử lý dữ liệu
  let isActived = false;
    map(vaiTroKeyword, vaiTro => {
      forOwn(selectData, (value, key) => {
        if (key === vaiTro && value.actived === true) {
          isActived = true;
        }
      })
    });

  return isActived;
}

/**
 * Lấy danh sách quyền để thiết lập trạng thái
 *
 * @param {*} quyens
 * @param {*} isAdmin
 * @returns - Trả về object chưa các quyền
 */
export const getListQuyen = (quyens, isAdmin, isXem) => {
  let quyen = { xem: false, sua: false, xoa: false, them: false };
  if (isAdmin) {
    quyen = { xem: true, sua: true, xoa: true, them: true };
    return quyen;
  }
  if (isXem){
    quyen = { xem: true, sua: false, xoa: false, them: false };
  }
  let xem = false;
  let sua = false;
  let xoa = false;
  let them = false;
  if (!isEmpty(quyens)) {
    map(quyens, item => {
      if (!xem) xem = boDauTiengViet(item.tenQuyen) === 'Xem';
      if (!sua) sua = boDauTiengViet(item.tenQuyen) === 'Sua';
      if (!xoa) xoa = boDauTiengViet(item.tenQuyen) === 'Xoa';
      if (!them) them = boDauTiengViet(item.tenQuyen) === 'Them';
    });
  };
  quyen = { xem, sua, xoa, them };
  return quyen;
}
